// Source-owned section routes. Longest matching route owns its descendants.
export const sectionRoutes = [
  { key: "hr.employees", route: "/hr/employees" },
  { key: "hr.attendance", route: "/hr/attendance" },
  { key: "hr.rosters", route: "/hr/rosters" },
  { key: "hr.timesheets", route: "/hr/timesheets" },
  { key: "hr.leave", route: "/hr/leave" },
  { key: "hr.training", route: "/hr/training" },
  { key: "hr.qualifications", route: "/hr/qualifications" },
  { key: "hr.medical", route: "/hr/medical" },
  { key: "hr.reports", route: "/hr/reports" },
  { key: "hr.setup", route: "/hr/setup" },

  { key: "training.modules", route: "/training/modules" },
  { key: "training.assignments", route: "/training/assignments" },
  { key: "training.assignments", route: "/training/matrix" },
  { key: "training.assessors", route: "/training/assessors" },
  {
    "key": "safety.safety_overview",
    "route": "/safety/overview"
  },
  {
    "key": "safety.safety_dashboard",
    "route": "/safety/dashboard"
  },
  {
    "key": "safety.safety_my_work",
    "route": "/safety/my-work"
  },
  {
    "key": "safety.safety_reports",
    "route": "/safety/reports"
  },
  {
    "key": "safety.safety_incidents",
    "route": "/safety/incidents"
  },
  {
    "key": "safety.safety_investigations",
    "route": "/safety/investigations"
  },
  {
    "key": "safety.safety_actions",
    "route": "/safety/actions"
  },
  {
    "key": "safety.safety_hazards",
    "route": "/safety/hazards"
  },
  {
    "key": "safety.safety_risk_register",
    "route": "/safety/risk-register"
  },
  {
    "key": "safety.safety_controls",
    "route": "/safety/controls"
  },
  {
    "key": "safety.safety_chemicals",
    "route": "/safety/chemicals"
  },
  {
    "key": "safety.safety_inspections",
    "route": "/safety/inspections"
  },
  {
    "key": "safety.safety_documents",
    "route": "/safety/documents"
  },
  {
    "key": "safety.safety_forms",
    "route": "/safety/forms"
  },
  {
    "key": "safety.safety_emergency",
    "route": "/safety/emergency"
  },
  {
    "key": "safety.safety_environment",
    "route": "/safety/environment"
  },
  {
    "key": "safety.safety_meetings",
    "route": "/safety/meetings"
  },
  {
    "key": "safety.safety_moc",
    "route": "/safety/moc"
  },
  {
    "key": "safety.safety_permits",
    "route": "/safety/permits"
  },
  {
    "key": "safety.safety_ppe",
    "route": "/safety/ppe"
  },
  {
    "key": "safety.safety_pre_starts",
    "route": "/safety/pre-starts"
  },
  {
    "key": "safety.safety_training",
    "route": "/safety/training"
  },
  {
    "key": "safety.safety_assets",
    "route": "/safety/assets"
  },
  {
    "key": "safety.safety_exports",
    "route": "/safety/exports"
  },
  {
    "key": "safety.safety_activity",
    "route": "/safety/activity"
  },
  {
    "key": "safety.safety_settings",
    "route": "/safety/settings"
  },
  {
    "key": "customers.company_customers",
    "route": "/company/customers"
  },
  {
    "key": "customers.company_pricing",
    "route": "/company/pricing"
  },
  {
    "key": "production.company_production",
    "route": "/company/production"
  },
  {
    "key": "geofences.company_geofences",
    "route": "/company/geofences"
  },
  {
    "key": "dispatch.company_dispatch_dashboard",
    "route": "/company/dispatch/dashboard"
  },
  {
    "key": "dispatch.company_dispatch_orders",
    "route": "/company/dispatch/orders"
  },
  {
    "key": "dispatch.company_dispatch_runs",
    "route": "/company/dispatch/runs"
  },
  {
    "key": "dispatch.company_dispatch_assets",
    "route": "/company/dispatch/assets"
  },
  {
    "key": "dispatch.company_dispatch_trackers",
    "route": "/company/dispatch/trackers"
  },
  {
    "key": "logistics.company_logistics",
    "route": "/company/logistics"
  },
  {
    "key": "logistics.company_people_drivers",
    "route": "/company/people/drivers"
  },
  {
    "key": "logistics.company_people_roster",
    "route": "/company/people/roster"
  },
  {
    "key": "logistics.company_people_timesheets",
    "route": "/company/people/timesheets"
  },
  {
    "key": "logistics.company_people_workforce",
    "route": "/company/people/workforce"
  },
  {
    "key": "logistics.company_people_leave",
    "route": "/company/people/leave"
  },
  {
    "key": "logistics.company_people_mobile_operations",
    "route": "/company/people/mobile-operations"
  },
  {
    "key": "logistics.company_people_training_compliance",
    "route": "/company/people/training-compliance"
  },
  {
    "key": "logistics.company_fleet",
    "route": "/company/fleet"
  },
  {
    "key": "logistics.company_routes",
    "route": "/company/routes"
  },
  {
    "key": "logistics.company_logistics_fixed_costs",
    "route": "/company/logistics/fixed-costs"
  },
  {
    "key": "logistics.company_logistics_reports",
    "route": "/company/logistics/reports"
  },
  {
    "key": "logistics.company_logistics_history",
    "route": "/company/logistics/history"
  },
  {
    "key": "logistics.company_logistics_audit",
    "route": "/company/logistics/audit"
  },
  {
    "key": "maintenance.company_maintenance",
    "route": "/company/maintenance"
  },
  {
    "key": "maintenance.company_maintenance_requests",
    "route": "/company/maintenance/requests"
  },
  {
    "key": "maintenance.company_maintenance_work_orders",
    "route": "/company/maintenance/work-orders"
  },
  {
    "key": "maintenance.company_maintenance_assets",
    "route": "/company/maintenance/assets"
  },
  {
    "key": "maintenance.company_maintenance_planner",
    "route": "/company/maintenance/planner"
  },
  {
    "key": "maintenance.company_maintenance_preventive",
    "route": "/company/maintenance/preventive"
  },
  {
    "key": "maintenance.company_maintenance_parts",
    "route": "/company/maintenance/parts"
  },
  {
    "key": "maintenance.company_maintenance_checklists",
    "route": "/company/maintenance/checklists"
  },
  {
    "key": "maintenance.company_maintenance_condition",
    "route": "/company/maintenance/condition"
  },
  {
    "key": "maintenance.company_maintenance_housekeeping",
    "route": "/company/maintenance/housekeeping"
  },
  {
    "key": "maintenance.company_maintenance_purchasing",
    "route": "/company/maintenance/purchasing"
  },
  {
    "key": "maintenance.company_maintenance_tools",
    "route": "/company/maintenance/tools"
  },
  {
    "key": "maintenance.company_maintenance_settings",
    "route": "/company/maintenance/settings"
  },
  {
    "key": "threadair.company_thread_air",
    "route": "/company/thread-air"
  },
  {
    "key": "threadair.company_thread_air_settings",
    "route": "/company/thread-air/settings"
  },
  {
    "key": "threadair.company_thread_air_handheld_settings",
    "route": "/company/thread-air/handheld-settings"
  },
  {
    "key": "threadair.company_rfid",
    "route": "/company/rfid"
  },
  {
    "key": "threadair.company_rfid_anomalies",
    "route": "/company/rfid/anomalies"
  },
  {
    "key": "threadair.company_rfid_floor",
    "route": "/company/rfid/floor"
  },
  {
    "key": "threadair.company_rfid_packing_slips",
    "route": "/company/rfid/packing-slips"
  },
  {
    "key": "threadair.company_rfid_reports",
    "route": "/company/rfid/reports"
  },
  {
    "key": "threadair.company_rfid_report_scopes",
    "route": "/company/rfid/report-scopes"
  },
  {
    "key": "threadair.company_rfid_engineering",
    "route": "/company/rfid/engineering"
  },
  {
    "key": "threadair.company_edge",
    "route": "/company/edge"
  },
  {
    "key": "reports.company_reports",
    "route": "/company/reports"
  },
  {
    "key": "reports.company_reports_sales_dashboard",
    "route": "/company/reports/sales-dashboard"
  },
  {
    "key": "reports.company_reports_logistics_weekly_costs",
    "route": "/company/reports/logistics-weekly-costs"
  },
  {
    "key": "reports.company_operations",
    "route": "/company/operations"
  },
  {
    "key": "contractors.contractors",
    "route": "/contractors"
  },
  {
    "key": "contractors.contractors_register",
    "route": "/contractors/register"
  },
  {
    "key": "contractors.contractors_inductions",
    "route": "/contractors/inductions"
  },
  {
    "key": "contractors.contractors_site_entry",
    "route": "/contractors/site-entry"
  },
  {
    "key": "contractors.contractors_site_visits",
    "route": "/contractors/site-visits"
  },
  {
    "key": "contractors.contractors_kiosks",
    "route": "/contractors/kiosks"
  },
  {
    "key": "company.company",
    "route": "/company"
  },
  {
    "key": "company.company_people",
    "route": "/company/people"
  },
  {
    "key": "company.company_roles",
    "route": "/company/roles"
  },
  {
    "key": "company.company_assets",
    "route": "/company/assets"
  },
  {
    "key": "company.company_integrations",
    "route": "/company/integrations"
  },
  {
    "key": "company.company_public_holidays",
    "route": "/company/public-holidays"
  },
  {
    "key": "company.company_qr_codes",
    "route": "/company/qr-codes"
  },
  {
    "key": "company.company_migration",
    "route": "/company/migration"
  },
  {
    "key": "settings.settings_automation",
    "route": "/settings/automation"
  },
  { "key": "contractors.portal", "route": "/portal" }
] as const;
